import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/Landing/Index.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/admin",
    name: "admin",
    // Usamos lazy-loading para que el código del admin solo se cargue cuando sea necesario
    component: () => import("../views/Dashboard/AdminDashboard.vue"),
    meta: { requiresAuth: true } // Marcamos que esta ruta necesita protección
  },
  {
    path: "/postular-negocio",
    name: "business-application",
    component: () => import("../views/BusinessApplicationView.vue")
  },
  {
    path: "/postular-repartidor",
    name: "driver-application",
    component: () => import("../views/DriverApplicationView.vue")
  },
  // Documentos legales de la plataforma
  {
    path: "/privacidad",
    name: "privacidad",
    component: () => import("../views/LegalView.vue"),
    meta: { legal: "privacidad" }
  },
  {
    path: "/terminos",
    name: "terminos",
    component: () => import("../views/LegalView.vue"),
    meta: { legal: "terminos" }
  },
  {
    path: "/cookies",
    name: "cookies",
    component: () => import("../views/LegalView.vue"),
    meta: { legal: "cookies" }
  },
  {
    path: "/seguridad",
    name: "seguridad",
    component: () => import("../views/LegalView.vue"),
    meta: { legal: "seguridad" }
  },
  // Ruta por defecto si alguien escribe cualquier cosa (404)
  {
    path: "/:pathMatch(.*)*",
    redirect: "/"
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // Al cambiar de página empieza arriba; al usar anclas respeta el offset del navbar fijo.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) {
      return { el: to.hash, top: 96, behavior: 'smooth' }
    }
    return { top: 0 }
  }
});

// --- GUARD DE NAVEGACIÓN ---
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('admin_auth') === 'true';

  // Si la ruta requiere autenticación y el usuario no está logueado
  if (to.meta.requiresAuth && !isAuthenticated) {
    // Aquí podrías redirigir a una página de login específica
    // pero como nuestro Login está integrado dentro de AdminDashboard.vue,
    // simplemente dejamos que pase y el componente mostrará el Login por su v-if interno.
    next();
  } else {
    next();
  }
});

export default router;